import * as React from 'react';
import {ChangeEvent, PureComponent} from 'react';
import LayerListRow from './layer-list-row';
import {Search} from "./search";
import {ILayerState, IMapState} from "../store/types";
import {layerIsVisible} from "../utils/layerIsVisible";
import {VerticalModal} from "./modal";
import {BasicModal} from "./basic-modal";
import {getLayerName} from "../utils/getLayerName";
import {validateName} from "../utils/validation";
import {html_space} from "../utils/space";
import Button from "antd/es/button/button";
import {Icon} from "antd";
import Dropdown from "antd/es/dropdown/dropdown";
import Menu from "antd/es/menu";
import Modal from "antd/es/modal/Modal";
import Select from "antd/es/select";
import {requestEntitiesAndContactsByLayerType} from "../http/requestEntitiesAndContactsByLayer";
// @ts-ignore
import { CSVLink } from "react-csv";
import {IEntitySearchResultNode, LayerVisibility} from "../types";
import {customSort} from "../utils/customSort";
import {escapeSearchChars} from "../utils/escapeSearchChars";
import {searchEntitiesAndContactsByLayerId} from "../http/searchEntitiesAndContactsByLayerId";
import * as wkx from 'wkx';
import {Buffer} from 'buffer';
import {DISPATCH_TYPES} from "../containers/map/mapDispatchToProps";
import {layerIsLoading} from '../utils/layerIsLoading';

const EXPORT_FILE_NAME = 'NAPD_GIS_layer_download';

interface INewLayer {
    type: string, layername: string, geoType: string, public: boolean
}

interface IProps {
    className?: string;
    layers: IMapState['layerIds'];
    databaseLayerIds: IMapState['databaseLayerIds'];
    sources: any;
    toggleLayer: DISPATCH_TYPES['toggleLayerVisibility'];
    panToFeature: (feature: IEntitySearchResultNode) => void;
    layerState: ILayerState;
    updateLayer: (type: string, layername: string) => void;
    deleteLayer: (layerId: string) => void;
    createLayer: (newLayerPatch: INewLayer) => void;
}

interface IState {
    showLayerList: boolean;
    isEditing: boolean;
    isExporting: boolean;
    isLoadingExport: boolean;
    layerToExport: any;
    editMode: EDIT_MODES | null;
    showModal: boolean;
    currentLayer?: string;
    tempChanges: any;
    isValid: boolean;
    csvContent: any;
    filename: string;
}

enum EDIT_MODES {
    RENAME = 0,
    CREATE = 1,
    DELETE = 2
}

const geoTypes = [
    'point',
    // 'line',
    // 'polygon'
];

const NEW_LAYER_KEY = 'NEW_LAYER_KEY';

export default class LayerList extends PureComponent <IProps, IState> {
    state: IState = {
        showLayerList: true,
        isEditing: false,
        isExporting: false,
        isLoadingExport: false,
        layerToExport: null,
        editMode: null,
        showModal: false,
        currentLayer: '',
        tempChanges: {},
        isValid: true,
        csvContent: null,
        filename: ''
    };

    toggleShowLayers = () => {
        const showLayerList = !this.state.showLayerList;
        this.setState({showLayerList});
    }

    convertWKBToWKT (wkb: string) {
        const wkbBuffer = new Buffer(wkb, 'hex');
        const geometry = wkx.Geometry.parse(wkbBuffer);
        return geometry.toWkt();
    }

    /*
    *
    *
    *    LayerName
    *    Name
    *    MemberType
    *    WebsiteURL
    *    POCID
    *    Notes
    *    PubConInfo
    *    Instruc
    *    DateLastChanged
    *    Geometry
    *
    * */
    prepDownloadLayers = async (layerToExport: string) => {
        // const {layerToExport} = this.state;
        this.setState({
            isLoadingExport: true
        });
        const result = await requestEntitiesAndContactsByLayerType(layerToExport);
        const headers = [
            // entity
            'Name',
            'Address',
            'City',
            'State',
            'Zip',
            'Jurisdiction',
            'Phone',
            'Email',
            'Website',
            'Contact IDs',
            'DateLastChanged',
            // contact
            'Contact ID',
            'Name',
            'Cell',
            'Email',
            'Edited By',
            'DateLastChanged',
            // geom
            // 'cartodb_id', // objectid
            // 'objectid',
            // 'fid_2', // null
            'the_geom',
        ];
        const rows = result.map((node) => ([
            node.name,
            node.address,
            node.city,
            node.state,
            node.zip,
            node.notes,
            node.phone,
            node.email,
            node.websiteurl,
            node.pocids,
            node.datelastchanged,

            node.contact?.pocid,
            node.contact?.name,
            node.contact?.cell,
            node.contact?.email,
            node.contact?.pubconinfo,
            node.contact?.datelastchanged,

            // node.objectid,
            // node.objectid,
            // node.fid2,
            this.convertWKBToWKT(node.geometry!)
        ]));

        const csvContent: any = [headers].concat(rows as any);
        this.setState({
            csvContent,
            isLoadingExport: false,
            isExporting: true,
            filename: `${EXPORT_FILE_NAME}.csv`
        });
    }

    searchEntities = (text: string, callback: any) => {
        const layerState = this.props.layerState;
        const layers = this.props.layers.filter(layer => layerIsVisible(layerState, layer));
        const layerIds = layers.map(type => this.props.databaseLayerIds[type]);
        const search = escapeSearchChars(text);
        const query = {search, layerIds};

        return searchEntitiesAndContactsByLayerId(query, callback);
        // return searchEntitiesAndContactsByLayer(query, callback);
        // return searchEntitiesByLayer(query, callback);
    }

    getLayerTitle  = (node: IEntitySearchResultNode) => {
        return node.name;
    }

    getLayerSubtitle = (node: IEntitySearchResultNode) => {
        return node.layername;
    }

    onEditLayer = (layer: string) => {
        const showModal = !this.state.showModal;
        if (showModal) {
            this.setState({
                currentLayer: layer,
                showModal,
                editMode: EDIT_MODES.RENAME
            })
        } else {
            this.setState({
                currentLayer: undefined,
                showModal,
                editMode: null
            })
        }

    }

    onDeleteLayer = (layer: string) => {
        const showModal = !this.state.showModal;
        if (showModal) {
            this.setState({
                currentLayer: layer,
                showModal,
                editMode: EDIT_MODES.DELETE
            })
        } else {
            this.setState({
                currentLayer: undefined,
                showModal,
                editMode: null
            })
        }
    }

    onSelect = (node: IEntitySearchResultNode) => {
        if (!layerIsVisible(this.props.layerState, node.type!)) {
            this.props.toggleLayer(node.type!);
        }
        this.props.panToFeature(node);
    }

    onEdit = () => {
        this.setState({isEditing: !this.state.isEditing});
    }

    onExport = () => {
        this.setState({isExporting: !this.state.isExporting})
    }

    onShowAll = () => {
        const {layers = []} = this.props;
        layers.forEach(layer => {
            this.props.toggleLayer(layer, LayerVisibility.visible);
        })
    }

    onHideAll = () => {
        const {layers = []} = this.props;
        layers.forEach(layer => {
            this.props.toggleLayer(layer, LayerVisibility.none);
        })
    }


    onExportSelect = async (layerToExport: string) => {
        this.setState({layerToExport});
        await this.prepDownloadLayers(layerToExport);
    }

    onLayerAdd = () => {
        const editMode = (this.state.editMode === EDIT_MODES.CREATE) ? null : EDIT_MODES.CREATE;
        this.setState({
            editMode,
            showModal: true,
            tempChanges: {
                [NEW_LAYER_KEY]: {
                    layername: '',
                    geoType: 'point',
                    public: false
                }
            },
            isValid: false
        });
    }

    getInputs = () => {
        const {layerState = {} as ILayerState} = this.props;
        const {currentLayer, tempChanges} = this.state;

        return [
            {
                value: getTempName(layerState, currentLayer!, tempChanges),
                label: 'name',
                onChange: (evt: ChangeEvent<HTMLInputElement>) =>
                    this.tempChange(currentLayer!, 'name', evt.target.value),
                message: <>
                    {(!validateName(getTempName(layerState, currentLayer!, tempChanges))) &&
                    <div className={'modal-input-error'}>
                        {html_space()} Invalid value for Layer Name
                    </div>
                    }
                </>
            }
        ]
    }

    _updateNewLayerKey = (event: ChangeEvent<HTMLSelectElement|HTMLInputElement>, key: string) => {
        let isValid = true;
        const value = (event.target as HTMLSelectElement|HTMLInputElement).value;
        const keys = ['layername', 'geoType'];

        const tempChanges = {
            ...this.state.tempChanges,
            [NEW_LAYER_KEY]: {
                ...this.state.tempChanges[NEW_LAYER_KEY],
                [key]: value
            }
        };

        keys.forEach(k => {
            if (k === 'layername') {
                isValid = isValid && validateName(tempChanges[NEW_LAYER_KEY][k])
            }

            if (k === 'geoType') {
                isValid = isValid && !!tempChanges[NEW_LAYER_KEY][k];
            }
        });

        this.setState({
            tempChanges,
            isValid
        });
    }

    _renderNewLayerPopup = () => {
        const {tempChanges} = this.state;
        const newLayer = tempChanges[NEW_LAYER_KEY];
        return <>
            <div>
                <div className="modal-input">
                    <div> Layer Name</div>
                    <input value={newLayer.layername} onChange={(e) =>
                        this._updateNewLayerKey(e, 'layername')}/>
                    {(!validateName(newLayer.layername)) &&
                        <div className={'modal-input-error'}>
                            {html_space()} Invalid value for Layer Name
                        </div>
                    }
                </div>
                {/*<div className="modal-input">*/}
                    {/*<div> Layer Type</div>*/}
                    {/*<input value={newLayer.type} onChange={(e) => this._updateNewLayerKey(e, 'type')}/>*/}
                {/*</div>*/}
                {/*<div>*/}
                {/*    <span>*/}
                {/*    <span className="label">Geo Type: </span>*/}
                {/*    <select value={newLayer.geoType}*/}
                {/*            onChange={(e) => this._updateNewLayerKey(e, 'geoType')}>*/}
                {/*        <option value={''} style={{display: 'none'}}>Select Geo Type</option>*/}
                {/*        <option value={''} disabled>Select Geo Type</option>*/}
                {/*        {geoTypes*/}
                {/*            .map(type =>*/}
                {/*                <option key={`popupContents-layerSelect-${type}`}*/}
                {/*                        value={type}>{type}</option>)}*/}
                {/*    </select>*/}
                {/*    </span>*/}
                {/*</div>*/}

                {/*<div>*/}
                    {/*<span>*/}
                    {/*<span className="label">Public Layer: </span>*/}
                    {/*<select value={newLayer.public} onChange={(e) => this._updateNewLayerKey(e, 'public')}>*/}
                        {/*<option value={'false'}>No</option>*/}
                        {/*<option value={'true'}>Yes</option>*/}
                    {/*</select>*/}
                    {/*</span>*/}
                {/*</div>*/}
            </div>
        </>
    }

    _renderDeleteLayerPopup = () => {
        const currentLayer = this.state.currentLayer!;
        const {layerState, sources} = this.props;
        const layer = layerState[currentLayer!];
        const layername = layer.name || '';
        const features = getFeaturesFromSources(sources, currentLayer);
        const message = (features && features.size > 0) ?
            'This layer has at least one entity. This will delete all entities in this layer. Do you wish to proceed?':
            'This layer has 0 entities. This will delete the layer permanently. Do you wish to proceed?';
        return <>
            <div>
                <div>
                    <span className="label">Delete Layer {layername}? </span>
                </div>
                <div>
                    <span className="sublabel warning">{message}</span>
                </div>
            </div>
        </>
    }

    _createLayer = () => {
        const newLayer: INewLayer = this.state.tempChanges[NEW_LAYER_KEY];
        if (newLayer.layername && newLayer.geoType) {
            this.props.createLayer!(newLayer);
            this.unsetTempChange(NEW_LAYER_KEY);
        }
    }

    _deleteLayer = () => {
        if (this.state.currentLayer) {
            this.props.deleteLayer(this.state.currentLayer)
        }
        this.setState({
            currentLayer: undefined,
            showModal: false,
            editMode: null
        });
    }

    _sortLayers = (layerA: string, layerB: string) => {
        const {layerState} = this.props;
        const nameA = getLayerName(layerA, layerState); // ignore upper and lowercase
        const nameB = getLayerName(layerB, layerState); // ignore upper and lowercase
        return customSort(nameA, nameB);
    }

    tempChange = (layer: string, key: string, value: string) => {
        let isValid = true;
        const changes = this.state.tempChanges[layer] || {};
        changes[key] = value;

        if (key === 'name') {
            isValid = validateName(value)
        }

        this.setState({
            tempChanges: {
                [layer]: changes
            },
            isValid
        });

    }

    unsetTempChange = (layer: string) => {
        this.setState({
            tempChanges: {
                [layer]: undefined
            },
            showModal: false,
        });
    }

    saveLayerChanges = (layer: string) => {
        if (this.state.tempChanges[layer]) {
            this.props.updateLayer(layer, this.state.tempChanges[layer].name);
        }
        this.setState({
            showModal: false
        })
    }

    renderDownloadButton () {
        const {csvContent, isLoadingExport} = this.state;
        return <Button key="submit" type="primary" size="large" disabled={!csvContent}
                       loading={isLoadingExport}>Download</Button>;
    }

    renderDownloadFooter () {
        const {csvContent, filename} = this.state;
        return <span key={'download'}>
            {html_space()}
            {!this.state.csvContent ?
                this.renderDownloadButton() :
                <CSVLink
                    data={ csvContent }
                    enclosingCharacter={'"'}
                    filename={ filename }
                    separator={','}
                    target="_blank"
                >
                {this.renderDownloadButton()}
                </CSVLink>
          }</span>
    }

    render () {
        const {className='', layers = [], layerState = {} as ILayerState, sources} = this.props;
        const {editMode, isEditing, isValid, showModal, currentLayer, tempChanges} = this.state;
        return (
            <div className={`${className} layerList`}>

                {showModal && isEditing && editMode === EDIT_MODES.RENAME && <VerticalModal
                    show={showModal}
                    onClose={() => {}}
                    cancel={() => this.unsetTempChange(currentLayer!)}
                    complete={() => this.saveLayerChanges(currentLayer!)}
                    title={getTempName(layerState, currentLayer!, tempChanges)}
                    invalid={!isValid}
                    inputs={this.getInputs()}
                />}

                {showModal && isEditing && editMode === EDIT_MODES.CREATE && <BasicModal
                    onClose={() => {this._createLayer()}}
                    cancel={() => this.unsetTempChange(NEW_LAYER_KEY)}
                    show={true}
                    content={this._renderNewLayerPopup()}
                    showCancel={true}
                    invalid={!isValid}
                    title={'Create Layer'}
                />}

                {showModal && isEditing && editMode === EDIT_MODES.DELETE && <BasicModal
                    onClose={() => {this._deleteLayer()}}
                    cancel={() => this.unsetTempChange(NEW_LAYER_KEY)}
                    show={true}
                    content={this._renderDeleteLayerPopup()}
                    showCancel={true}
                    title={'Delete Layer'}
                />}

                <div className={`${className} layerListHeader`}>
                    <Search
                        inputPosition={'top'}
                        inputPlaceholder={'Search Visible Layers'}
                        resultsClass={'searchResults'}
                        search={this.searchEntities}
                        getName={this.getLayerTitle}
                        getSubtitle={this.getLayerSubtitle}
                        onSelect={this.onSelect}
                        showLoader={true}
                    />
                    <div style={{marginLeft: 'auto', padding: '5px'}}>
                        {/*<div className={`layerListRowMenu`} onClick={this.onEdit}>*/}
                            {/*<span className={`btn fas fa-pencil-alt ${isEditing ? 'active' : ''}`}/>*/}
                        {/*</div>*/}
                        {isEditing && <Icon className={'btn'} type={'stop'} onClick={this.onEdit}/>}
                        {!isEditing && <Dropdown overlay={
                            (
                                <Menu>
                                    <Menu.Item key="1" onClick={this.onEdit}>Edit Layers</Menu.Item>
                                    <Menu.Item key="2" onClick={this.onExport}>Export Layers</Menu.Item>
                                    <Menu.Item key="3" onClick={this.onShowAll}>Show All Layers</Menu.Item>
                                    <Menu.Item key="4" onClick={this.onHideAll}>Hide All Layers</Menu.Item>
                                </Menu>
                            )
                        } trigger={['click']}>
                            <Icon type={'menu-unfold'}/>
                        </Dropdown>}

                        <Modal
                            visible={this.state.isExporting}
                            title="Export Layers"
                            onCancel={this.onExport}
                            footer={[
                                <Button key="back" size="large" onClick={this.onExport}>Cancel</Button>,
                                this.renderDownloadFooter()
                            ]}
                        >
                            <Select defaultValue="select layer" style={{ width: 200 }} onChange={this.onExportSelect}>
                                {layers.map((layer: string) =>
                                    <Select.Option value={layer} key={layer}>
                                        {layerState[layer]?.name}
                                    </Select.Option>
                                )}
                            </Select>
                        </Modal>

                        {/*<div className={'btn'}>*/}
                            {/*<Icon type={'menu-unfold'} onClick={this.toggleExpandLayer}/>*/}
                        {/*</div>*/}
                    </div>
                </div>
                <div className={`layerListContent`}>
                    {isEditing &&
                        <div>
                            <Button type="link" icon="plus-circle" size={'small'} onClick={this.onLayerAdd}>
                                Add Layer
                            </Button>
                        </div>
                    // <div className={`layerListRowMenu`} onClick={this.onLayerAdd}>
                    //     Add Layer <Icon type={'plus-circle'}/>
                    // </div>
                    }
                    {layers.map((layer, index) => {
                        return <LayerListRow
                            key={index}
                            layerId={layer}
                            layerName={getName(layerState, layer)}
                            visible={layerIsVisible(layerState, layer)}
                            loading={layerIsLoading(layerState, layer)}
                            toggleLayer={this.props.toggleLayer}
                            editLayer={this.onEditLayer}
                            deleteLayer={this.onDeleteLayer}
                            editing={isEditing}
                            features={getFeaturesFromSources(sources, layer)}
                            selectedFeatures={getSelectedFeatures(sources)}
                            panToFeature={this.props.panToFeature}
                        />
                    })}
                </div>

            </div>
        );
    }
}

function getTempName (layerState: ILayerState, currentLayer: string, tempChanges: any) {
    return (tempChanges[currentLayer] && tempChanges[currentLayer].name) || getName(layerState, currentLayer)
}

// @ts-ignore
// function getTempGeoType (layerState: ILayerState, currentLayer: string, tempChanges: any) {
//     return tempChanges[currentLayer] && tempChanges[currentLayer].geoType;
// }

function getName (layerState: ILayerState, layerId: string) {
    return (layerState[layerId] && layerState[layerId].name) ? layerState[layerId].name : layerId;
}

function getSelectedFeatures (sources: any) {
    const layers = ['points_highlighted', 'polygons_highlighted', 'lines_highlighted'];
    const points = getFeaturesFromSources(sources, layers[0]);
    const polygons = getFeaturesFromSources(sources, layers[1]);
    const lines = getFeaturesFromSources(sources, layers[2]);
    return points?.concat(polygons)?.concat(lines);
}

function getFeaturesFromSources (sources: any, layer: string) {
    if (!sources) {
        return [];
    }
    try {
        return sources.getIn([layer, 'data', 'features']).sort(sortFeatures);
    } catch (e) {
        return [];
    }
}

function sortFeatures (a: any, b: any) {
    const name1 = a.getIn(['properties', 'name'], '(No Name)');
    const name2 = b.getIn(['properties', 'name'], '(No Name)');
    return customSort(name1, name2);
}

